import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Acquiring = {
  __typename?: 'Acquiring';
  /** Курсы эквайринга */
  courses?: Maybe<Array<Course>>;
  createdAt: Scalars['Date']['output'];
  /** Данные интеграции эквайринга */
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  /** Название инстанса экфайринга */
  title: Scalars['String']['output'];
  /** Транзакции эквайринга */
  transactions?: Maybe<Array<Transaction>>;
  /** Ресурс эквайринга */
  type: AcquiringType;
  updatedAt: Scalars['Date']['output'];
};

export enum AcquiringType {
  Sberbank = 'SBERBANK',
  Yoomoney = 'YOOMONEY'
}

export type AuthTokensDto = {
  __typename?: 'AuthTokensDto';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type Block = {
  __typename?: 'Block';
  /** Тип доступа к блоку */
  availabilityType: BlockAvailabilityType;
  /** Стоимость блока */
  cost: Scalars['Float']['output'];
  /** Курс, к которому привязан блок */
  course: Course;
  /** ID курса */
  courseId: Scalars['ID']['output'];
  /** Файл обложки блока */
  coverFile?: Maybe<File>;
  /** ID файла обложки блока */
  coverFileId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Дата начала уроков блока */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания уроков блока */
  dateTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Уроки блока */
  lessons?: Maybe<Array<Lesson>>;
  /** Порядковый номер блока */
  order: Scalars['Int']['output'];
  /** Название блока */
  title: Scalars['String']['output'];
  /** Транзакции по блоку */
  transactions?: Maybe<Array<Transaction>>;
  updatedAt: Scalars['Date']['output'];
  /** Пользователи блока */
  userBlocks?: Maybe<Array<UserBlock>>;
};

export enum BlockAvailabilityType {
  Issued = 'ISSUED',
  Mixed = 'MIXED',
  Payable = 'PAYABLE',
  Trial = 'TRIAL'
}

export type BlockLkDto = {
  __typename?: 'BlockLkDto';
  /** Тип доступа к блоку */
  availabilityType: BlockAvailabilityType;
  /** Стоимость блока */
  cost: Scalars['Float']['output'];
  /** ID курса */
  courseId: Scalars['ID']['output'];
  /** Файл обложки блока */
  coverFile?: Maybe<FileLkDto>;
  /** Дата начала уроков блока */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания уроков блока */
  dateTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Доступен ли блок пользователю */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Уроки блока */
  lessons?: Maybe<Array<LessonLkDto>>;
  /** Порядковый номер блока */
  order: Scalars['Int']['output'];
  /** Статистика блока */
  statistic?: Maybe<ProgressStatistic>;
  /** Название блока */
  title: Scalars['String']['output'];
  /** Причина недоступности блока */
  unavailableReason?: Maybe<UnavailableReason>;
};

export type BlockPresentationLkDto = {
  __typename?: 'BlockPresentationLkDto';
  /** Тип доступа к блоку */
  availabilityType: BlockAvailabilityType;
  /** Стоимость блока */
  cost: Scalars['Float']['output'];
  /** ID курса */
  courseId: Scalars['ID']['output'];
  /** Файл обложки блока */
  coverFile?: Maybe<FileLkDto>;
  /** Дата начала уроков блока */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания уроков блока */
  dateTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Порядковый номер блока */
  order: Scalars['Int']['output'];
  /** Название блока */
  title: Scalars['String']['output'];
};

export type ColorTheme = {
  __typename?: 'ColorTheme';
  /** Цвет в формате HEX */
  color: Scalars['String']['output'];
  /** Курсы привязанные к цветовой теме */
  courses?: Maybe<Array<Course>>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ColorThemeLkDto = {
  __typename?: 'ColorThemeLkDto';
  /** Цвет в формате HEX */
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type CompletenessType = {
  __typename?: 'CompletenessType';
  /** Завершён ли прогресс по всемэлементам */
  isComplete: Scalars['Boolean']['output'];
  /** Есть ли прогресс по всемэлементам */
  isDone: Scalars['Boolean']['output'];
};

export type CountType = {
  __typename?: 'CountType';
  completeCount: Scalars['Float']['output'];
  doneCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type Course = {
  __typename?: 'Course';
  /** Эквайринг курса */
  acquiring?: Maybe<Acquiring>;
  /** Id эквайринга */
  acquiringId?: Maybe<Scalars['ID']['output']>;
  /** Рекламные карточки */
  advertising?: Maybe<Array<CourseCardAdvertising>>;
  /** Блоки курса */
  blocks?: Maybe<Array<Block>>;
  /** Карточки курса */
  cards?: Maybe<Array<CourseCard>>;
  /** Цветовая тема курса */
  colorTheme?: Maybe<ColorTheme>;
  /** ID цветовой темы */
  colorThemeId?: Maybe<Scalars['ID']['output']>;
  /** Стоимость курса в рублях */
  cost: Scalars['Float']['output'];
  /** Кураторы курса */
  courseCurators?: Maybe<Array<CourseCurator>>;
  /** Файл обложка курса */
  coverFile?: Maybe<File>;
  /** ID файла */
  coverFileId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Дата начала курса */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания курса */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Описание курса */
  description?: Maybe<Scalars['String']['output']>;
  /** Класс предмета */
  grade: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Скрыт ли курс */
  isHidden: Scalars['Boolean']['output'];
  /** Числовой ID курса */
  numericId: Scalars['Int']['output'];
  /** Используется ли курс в онбординг-боте */
  onboarding: Scalars['Boolean']['output'];
  /** Тема курса */
  subject: CourseSubject;
  /** Заголовок курса */
  title?: Maybe<Scalars['String']['output']>;
  /** Транзакции по курсу */
  transactions?: Maybe<Array<Transaction>>;
  updatedAt: Scalars['Date']['output'];
  /** Пользователи курса */
  userCourses?: Maybe<Array<UserCourse>>;
};

export type CourseCard = {
  __typename?: 'CourseCard';
  /** Курсы в которых отображать карточку */
  advertising?: Maybe<Array<CourseCardAdvertising>>;
  /** Курс, к которому привязана карточка */
  course: Course;
  /** ID курса */
  courseId: Scalars['ID']['output'];
  /** Файл обложка карточки */
  coverFile?: Maybe<File>;
  /** ID файла */
  coverFileId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Описание */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Скрыта ли карточка */
  isHidden: Scalars['Boolean']['output'];
  /** Ссылка карточки */
  link?: Maybe<Scalars['String']['output']>;
  /** Тип карточки */
  type: CourseCardType;
  updatedAt: Scalars['Date']['output'];
  /** Использовать ли обложку из курса */
  useDefaultCover: Scalars['Boolean']['output'];
};

export type CourseCardAdvertising = {
  __typename?: 'CourseCardAdvertising';
  /** Карточка */
  card: CourseCard;
  /** ID карточки */
  cardId: Scalars['ID']['output'];
  /** Курс, в котором показывать карточку  */
  course: Course;
  /** ID курса */
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CourseCardAdvertisingLkDto = {
  __typename?: 'CourseCardAdvertisingLkDto';
  /** Карточка */
  card: CourseCardLkDto;
  /** ID карточки */
  cardId: Scalars['ID']['output'];
  /** Курс, в котором показывать карточку  */
  course: CoursePresentationLkDto;
  /** ID курса */
  courseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type CourseCardLkDto = {
  __typename?: 'CourseCardLkDto';
  /** Курс, к которому привязана карточка */
  course: CoursePresentationLkDto;
  /** Файл обложка карточки */
  coverFile?: Maybe<FileLkDto>;
  /** Описание */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ссылка карточки */
  link?: Maybe<Scalars['String']['output']>;
  /** Тип карточки */
  type: CourseCardType;
  /** Использовать ли обложку из курса */
  useDefaultCover: Scalars['Boolean']['output'];
};

export enum CourseCardType {
  Advertising = 'ADVERTISING',
  Onboarding = 'ONBOARDING',
  Presentation = 'PRESENTATION',
  Purchase = 'PURCHASE'
}

export type CourseCurator = {
  __typename?: 'CourseCurator';
  /** Курс */
  course: Course;
  /** ID курса */
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Порядок */
  order: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user: User;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export type CourseLkDto = {
  __typename?: 'CourseLkDto';
  /** Рекламные карточки */
  advertising?: Maybe<Array<CourseCardAdvertisingLkDto>>;
  /** Блоки курса */
  blocks?: Maybe<Array<BlockLkDto>>;
  /** Карточки курса */
  cards?: Maybe<Array<CourseCardLkDto>>;
  /** Цветовая тема курса */
  colorTheme?: Maybe<ColorThemeLkDto>;
  /** Стоимость курса в рублях */
  cost: Scalars['Float']['output'];
  /** Файл обложка курса */
  coverFile?: Maybe<FileLkDto>;
  /** Дата начала курса */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания курса */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Описание курса */
  description?: Maybe<Scalars['String']['output']>;
  /** Класс предмета */
  grade: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Тема курса */
  subject: CourseSubject;
  /** Заголовок курса */
  title?: Maybe<Scalars['String']['output']>;
  /** Данные о приобритении курса */
  userCourse?: Maybe<UserCourseLkDto>;
};

export type CoursePresentationLkDto = {
  __typename?: 'CoursePresentationLkDto';
  /** Карточки курса */
  cards?: Maybe<Array<CourseCardLkDto>>;
  /** Цветовая тема курса */
  colorTheme?: Maybe<ColorThemeLkDto>;
  /** Стоимость курса в рублях */
  cost: Scalars['Float']['output'];
  /** Файл обложка курса */
  coverFile?: Maybe<FileLkDto>;
  /** Дата начала курса */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания курса */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Описание курса */
  description?: Maybe<Scalars['String']['output']>;
  /** Класс предмета */
  grade: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Тема курса */
  subject: CourseSubject;
  /** Заголовок курса */
  title?: Maybe<Scalars['String']['output']>;
};

export enum CourseSubject {
  Biology = 'BIOLOGY',
  Chemistry = 'CHEMISTRY',
  History = 'HISTORY',
  Informatics = 'INFORMATICS',
  Literature = 'LITERATURE',
  Math = 'MATH',
  Physics = 'PHYSICS',
  RussianLanguage = 'RUSSIAN_LANGUAGE',
  SocialScience = 'SOCIAL_SCIENCE'
}

export type CreateAnswerFeedbackInput = {
  /** ID ответа пользователя */
  answerId: Scalars['ID']['input'];
  /** Прикреплённые файлы */
  files?: InputMaybe<Array<FileInput>>;
  /** Сообщение */
  message: Scalars['String']['input'];
};

export type CreateFewAnswerInput = {
  /** Список ID частей элементов */
  elementPartIds: Array<Scalars['ID']['input']>;
};

export type CreateFileAnswerInput = {
  /** Файлы с ответом */
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Текстовый ответ пользователя */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMatchingAnswerInput = {
  /** Список ID частей элементов и ответов пользователя */
  answers: Array<MatchingAnswerInput>;
};

export type CreateSingleAnswerInput = {
  /** ID части элемента */
  elementPartId: Scalars['ID']['input'];
};

export type CreateTextAnswerInput = {
  /** Текстовый ответ пользователя */
  text: Scalars['String']['input'];
};

export type CreateUserAnswerInput = {
  elementId: Scalars['ID']['input'];
  fewAnswerInput?: InputMaybe<CreateFewAnswerInput>;
  fileAnswerInput?: InputMaybe<CreateFileAnswerInput>;
  matchingAnswerInput?: InputMaybe<CreateMatchingAnswerInput>;
  singleAnswerInput?: InputMaybe<CreateSingleAnswerInput>;
  textAnswerInput?: InputMaybe<CreateTextAnswerInput>;
};

/** Элемент задания */
export type Element = {
  createdAt: Scalars['Date']['output'];
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

/** Файл, прикрепленный к элементу */
export type ElementFile = {
  __typename?: 'ElementFile';
  createdAt: Scalars['Date']['output'];
  /** Элемент новостей */
  element: Element;
  /** ID элемента */
  elementId: Scalars['ID']['output'];
  /** Прикрепленный файл */
  file: File;
  /** ID прикрепленного файла */
  fileId: Scalars['ID']['output'];
  /** Название файла при отправке */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Порядковый номер файла элемента */
  order?: Maybe<Scalars['Int']['output']>;
  /** Тип файла элемента */
  type: ElementFileType;
  updatedAt: Scalars['Date']['output'];
};

export type ElementFileLkDto = {
  __typename?: 'ElementFileLkDto';
  /** ID элемента */
  elementId: Scalars['ID']['output'];
  /** Прикрепленный файл */
  file: FileLkDto;
  /** Название файла при отправке */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Порядковый номер файла элемента */
  order?: Maybe<Scalars['Int']['output']>;
  /** Тип файла элемента */
  type: ElementFileType;
};

export enum ElementFileType {
  Content = 'CONTENT',
  Cover = 'COVER',
  Download = 'DOWNLOAD'
}

export type ElementLkDto = {
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
};

export type ElementPart = {
  __typename?: 'ElementPart';
  /** Содержание части элемента */
  content?: Maybe<Scalars['String']['output']>;
  /** Правильный ответ */
  correctAnswer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Вопрос к части элемента */
  element?: Maybe<Element>;
  /** ID Вопроса */
  elementId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Обозначение правильного ответа */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** Порядковый номер части элемента */
  order?: Maybe<Scalars['Int']['output']>;
  /** Тип части элемента */
  type: ElementPartType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
};

export type ElementPartLkDto = {
  __typename?: 'ElementPartLkDto';
  /** Содержание части элемента */
  content?: Maybe<Scalars['String']['output']>;
  /** ID Вопроса */
  elementId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Порядковый номер части элемента */
  order?: Maybe<Scalars['Int']['output']>;
  /** Тип части элемента */
  type: ElementPartType;
};

export enum ElementPartType {
  Answer = 'ANSWER',
  Matching = 'MATCHING'
}

export enum ElementType {
  ExerciseLink = 'EXERCISE_LINK',
  Feedback = 'FEEDBACK',
  File = 'FILE',
  Heading = 'HEADING',
  Question = 'QUESTION',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type Exercise = {
  __typename?: 'Exercise';
  createdAt: Scalars['Date']['output'];
  /** Дата начала задания */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания задания */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Задания урока */
  elements?: Maybe<Array<Element>>;
  id: Scalars['ID']['output'];
  /** Учитывается ли урок в прогрессе */
  inProgress: Scalars['Boolean']['output'];
  /** Урок, к которому привязано задание */
  lesson: Lesson;
  /** ID урока */
  lessonId: Scalars['ID']['output'];
  /** Порядковый номер задания */
  order: Scalars['Int']['output'];
  /** Время прохождения задания в секундах */
  timeLimit?: Maybe<Scalars['Float']['output']>;
  /** Заголовок задания */
  title: Scalars['String']['output'];
  /** ип задания */
  type: ExerciseType;
  updatedAt: Scalars['Date']['output'];
};

/** Элемент ссылки на задание */
export type ExerciseLinkElement = Element & {
  __typename?: 'ExerciseLinkElement';
  createdAt: Scalars['Date']['output'];
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

export type ExerciseLinkElementLkDto = ElementLkDto & {
  __typename?: 'ExerciseLinkElementLkDto';
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
};

export type ExerciseLkDto = {
  __typename?: 'ExerciseLkDto';
  /** Завершенность задания пользователем */
  completeness?: Maybe<CompletenessType>;
  /** Дата начала задания */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания задания */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Элементы */
  elements?: Maybe<Array<ElementLkDto>>;
  id: Scalars['ID']['output'];
  /** Учитывается ли урок в прогрессе */
  inProgress: Scalars['Boolean']['output'];
  /** Доступено ли задание пользователю */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** ID урока */
  lessonId: Scalars['ID']['output'];
  /** Порядковый номер задания */
  order: Scalars['Int']['output'];
  /** Время прохождения задания в секундах */
  timeLimit?: Maybe<Scalars['Float']['output']>;
  /** Заголовок задания */
  title: Scalars['String']['output'];
  /** ип задания */
  type: ExerciseType;
  /** Причина недоступности задания */
  unavailableReason?: Maybe<UnavailableReason>;
  /** Статистика пользователя по заданию */
  userStatistic?: Maybe<ExerciseStatistic>;
};

export type ExerciseStatistic = {
  __typename?: 'ExerciseStatistic';
  maxScoreA?: Maybe<Scalars['Float']['output']>;
  maxScoreB?: Maybe<Scalars['Float']['output']>;
  scoreA?: Maybe<Scalars['Float']['output']>;
  scoreB?: Maybe<Scalars['Float']['output']>;
};

export enum ExerciseType {
  Homework = 'HOMEWORK',
  Lecture = 'LECTURE'
}

/** Обратная связь */
export type FeedbackElement = Element & {
  __typename?: 'FeedbackElement';
  createdAt: Scalars['Date']['output'];
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

export type FeedbackElementLkDto = ElementLkDto & {
  __typename?: 'FeedbackElementLkDto';
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Ключ файла в S3 */
  key: Scalars['String']['output'];
  /** Название файла */
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Ссылка на файл */
  url: Scalars['String']['output'];
};

/** Скачивание файла */
export type FileElement = Element & {
  __typename?: 'FileElement';
  createdAt: Scalars['Date']['output'];
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

export type FileElementLkDto = ElementLkDto & {
  __typename?: 'FileElementLkDto';
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
};

export type FileInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};

export type FileLkDto = {
  __typename?: 'FileLkDto';
  /** Ключ файла в S3 */
  key: Scalars['String']['output'];
  /** Название файла */
  name: Scalars['String']['output'];
  /** Ссылка на файл */
  url: Scalars['String']['output'];
};

export type FullElementPartLkDto = {
  __typename?: 'FullElementPartLkDto';
  /** Содержание части элемента */
  content?: Maybe<Scalars['String']['output']>;
  /** Правильный ответ */
  correctAnswer?: Maybe<Scalars['String']['output']>;
  /** ID Вопроса */
  elementId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Обозначение правильного ответа */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** Порядковый номер части элемента */
  order?: Maybe<Scalars['Int']['output']>;
  /** Тип части элемента */
  type: ElementPartType;
};

/** Заголовок */
export type HeadingElement = Element & {
  __typename?: 'HeadingElement';
  createdAt: Scalars['Date']['output'];
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Текст заголовок */
  title?: Maybe<Scalars['String']['output']>;
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

export type HeadingElementLkDto = ElementLkDto & {
  __typename?: 'HeadingElementLkDto';
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Текст заголовок */
  title?: Maybe<Scalars['String']['output']>;
  /** Тип элемента */
  type: ElementType;
};

export type InitResourcePurchaseInput = {
  /** Id покупаемого ресурса */
  resourceId: Scalars['ID']['input'];
  /** Тип ресурса */
  resourceType: ResourceType;
};

export type Lesson = {
  __typename?: 'Lesson';
  /** Блок, к которому привязан урок */
  block: Block;
  /** ID блока */
  blockId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Дата начала урока */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания урока */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Задания урока */
  exercises?: Maybe<Array<Exercise>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер урока */
  order: Scalars['Int']['output'];
  /** Название урока */
  title: Scalars['String']['output'];
  /** Доступен ли урок в пробной версии */
  trial: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type LessonLkDto = {
  __typename?: 'LessonLkDto';
  /** ID блока */
  blockId: Scalars['ID']['output'];
  /** Завершенность урока пользователем */
  completeness?: Maybe<CompletenessType>;
  /** Дата начала урока */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания урока */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Задания урока */
  exercises?: Maybe<Array<ExerciseLkDto>>;
  /** Есть ли в уроке элемент вопроса с файловым ответом */
  hasFileAnswerQuestion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Доступен ли урок пользователю */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Порядковый номер урока */
  order: Scalars['Int']['output'];
  /** Название урока */
  title: Scalars['String']['output'];
  /** Доступен ли урок в пробной версии */
  trial: Scalars['Boolean']['output'];
  /** Причина недоступности урока */
  unavailableReason?: Maybe<UnavailableReason>;
};

export type MatchingAnswerInput = {
  /** ID части элемента */
  elementPartId: Scalars['ID']['input'];
  /** Ответ пользователя */
  text: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Создание прогресса для задания */
  commitProgress: Scalars['Boolean']['output'];
  /** Создание обпатной связи на ответ */
  createAnswerFeedback?: Maybe<UserAnswerLkDto>;
  /** Создание прогресса на элемент */
  createSingleProgress: UserProgressLkDto;
  /** Создание ответов на элемент вопроса */
  createUserAnswer: Array<UserAnswerLkDto>;
  /** Приобретение пробной версии */
  getTrial: Scalars['Boolean']['output'];
  /** Инициализация покупки */
  initPayment: Scalars['String']['output'];
  /** Авторизация связке номер телефона + пароль */
  loginByCredentials: AuthTokensDto;
  /** Авторизация по токену с данными из виджета авторизации телеграма */
  loginByTelegram: AuthTokensDto;
  /** Авторизация по токену с данными из телеграма */
  loginByTelegramToken: AuthTokensDto;
  /** Обновление токенов авторизации */
  refreshTokens: AuthTokensDto;
  /** Инициализация отправки файла из курса в бота */
  sendFileInChatBot: Scalars['Boolean']['output'];
  /** Установка первичного коментария пользователя */
  setUserComment: Scalars['Boolean']['output'];
  /** Обновление данных пользователя */
  updateUserData: UserLkDto;
};


export type MutationCommitProgressArgs = {
  exerciseId: Scalars['ID']['input'];
};


export type MutationCreateAnswerFeedbackArgs = {
  input: CreateAnswerFeedbackInput;
};


export type MutationCreateSingleProgressArgs = {
  elementId: Scalars['ID']['input'];
};


export type MutationCreateUserAnswerArgs = {
  input: CreateUserAnswerInput;
};


export type MutationGetTrialArgs = {
  coursesIds: Array<Scalars['ID']['input']>;
};


export type MutationInitPaymentArgs = {
  input: InitResourcePurchaseInput;
  receiptEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginByCredentialsArgs = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationLoginByTelegramArgs = {
  token: Scalars['String']['input'];
};


export type MutationLoginByTelegramTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationRefreshTokensArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationSendFileInChatBotArgs = {
  elementFileId: Scalars['ID']['input'];
};


export type MutationSetUserCommentArgs = {
  comment: Scalars['String']['input'];
};


export type MutationUpdateUserDataArgs = {
  input: SelfUpdateUserDataInput;
};

export type PreviewUserLkDto = {
  __typename?: 'PreviewUserLkDto';
  /** Файл аватара пользователя */
  avatarFile?: Maybe<FileLkDto>;
  /** Имя пользователя */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Фамилия пользователя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество пользователя */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Числовой ID пользователя */
  numericId: Scalars['Int']['output'];
  /** Название роли */
  role: RoleName;
  /** Username пользоателя из телеграма */
  telegramUsername?: Maybe<Scalars['String']['output']>;
};

export type ProgressStatistic = {
  __typename?: 'ProgressStatistic';
  /** Прогресс домашних заданий */
  homeworkScore: Array<ScoreType>;
  /** Прогресс лекций */
  lectureScore: ScoreType;
  /** Прогресс по урокам */
  lessonsCount: CountType;
  /** Прогресс по курса в процентах */
  progress: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Карточки курсов пользователя */
  availableCourseCards: Array<CourseCardLkDto>;
  block: BlockLkDto;
  blockPresentation?: Maybe<BlockPresentationLkDto>;
  /** Возвращает курс по Id */
  course: CourseLkDto;
  /** Карточка курса по типу */
  courseCard: CourseCardLkDto;
  /** Карточка курса по id */
  courseCardById?: Maybe<CourseCardLkDto>;
  /** Карточки доступных курсов */
  courseCards: Array<CourseCardLkDto>;
  /** Статистика курса */
  courseStatistic: ProgressStatistic;
  /** Задание по айди */
  exercise: ExerciseLkDto;
  lesson: LessonLkDto;
  /** Текущий пользователь */
  me: UserLkDto;
  /** Карточки онбординг курсов */
  onboardingCourseCards: Array<CourseCardLkDto>;
  /** Рекламные карточки для пользователя */
  userAdvertisingCourseCard?: Maybe<Array<CourseCardLkDto>>;
};


export type QueryBlockArgs = {
  blockId: Scalars['ID']['input'];
};


export type QueryBlockPresentationArgs = {
  blockId: Scalars['ID']['input'];
};


export type QueryCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryCourseCardArgs = {
  cardType: CourseCardType;
  courseId: Scalars['String']['input'];
};


export type QueryCourseCardByIdArgs = {
  courseCardId: Scalars['String']['input'];
};


export type QueryCourseStatisticArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
};


export type QueryLessonArgs = {
  lessonId: Scalars['ID']['input'];
};


export type QueryOnboardingCourseCardsArgs = {
  grade?: InputMaybe<Scalars['Float']['input']>;
  subject?: InputMaybe<CourseSubject>;
};

/** Вопрос */
export type QuestionElement = Element & {
  __typename?: 'QuestionElement';
  createdAt: Scalars['Date']['output'];
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** Баллы за вопрос */
  maxScore?: Maybe<Scalars['Float']['output']>;
  /** Баллы за не правильный ответ */
  negativeScore?: Maybe<Scalars['Float']['output']>;
  /** Номер */
  number: Scalars['Float']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Подсказка в поле ответа */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Баллы за правильный ответ */
  positiveScore?: Maybe<Scalars['Float']['output']>;
  /** Тип вопроса */
  questionType: QuestionType;
  /** Тип автоматической проверки вопроса */
  scoreType: QuestionScoreType;
  /** Оглавление */
  title?: Maybe<Scalars['String']['output']>;
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

export type QuestionElementLkDto = ElementLkDto & {
  __typename?: 'QuestionElementLkDto';
  /** Список правильных ответов */
  correctAnswers?: Maybe<Array<FullElementPartLkDto>>;
  /** Текущие ответы пользователя */
  currentUserAnswers?: Maybe<Array<UserAnswerLkDto>>;
  /** Текущий прогресс пользователя по элементу */
  currentUserProgress?: Maybe<UserProgressLkDto>;
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Варианты ответов в ворпосе на соответствие */
  matchingAnswers?: Maybe<Array<Scalars['String']['output']>>;
  /** Номер */
  number: Scalars['Float']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Подсказка в поле ответа */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Тип вопроса */
  questionType: QuestionType;
  /** Оглавление */
  title?: Maybe<Scalars['String']['output']>;
  /** Тип элемента */
  type: ElementType;
};

/** Тип автоматической проверки вопроса вопроса */
export enum QuestionScoreType {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

/** Тип вопроса */
export enum QuestionType {
  FewAnswers = 'FEW_ANSWERS',
  FileAnswer = 'FILE_ANSWER',
  Matching = 'MATCHING',
  SingleAnswer = 'SINGLE_ANSWER',
  TextAnswers = 'TEXT_ANSWERS'
}

export type RefreshToken = {
  __typename?: 'RefreshToken';
  createdAt: Scalars['Date']['output'];
  /** Дата истечения токена */
  expireAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Пользователь токена */
  user: User;
  /** Id пользователя */
  userId: Scalars['ID']['output'];
};

export enum ResourceType {
  Block = 'Block',
  Course = 'Course'
}

export enum RoleName {
  Admin = 'ADMIN',
  Curator = 'CURATOR',
  User = 'USER'
}

export type ScoreType = {
  __typename?: 'ScoreType';
  /** Максимальное количество баллов */
  maxScore: Scalars['Float']['output'];
  /** Количество баллов */
  score?: Maybe<Scalars['Float']['output']>;
};

export type SelfUpdateUserDataInput = {
  /** Файл аватарки пользователя */
  avatarFile?: InputMaybe<Scalars['Upload']['input']>;
  /** Дата рождения пользователя */
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  /** Комментарий о пользователи внутри системы */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Имя пользователя */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия пользователя */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество пользователя */
  middleName?: InputMaybe<Scalars['String']['input']>;
};

/** Текстовый элемент */
export type TextElement = Element & {
  __typename?: 'TextElement';
  /** Содержание */
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

export type TextElementLkDto = ElementLkDto & {
  __typename?: 'TextElementLkDto';
  /** Содержание */
  content: Scalars['String']['output'];
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
};

export type Transaction = {
  __typename?: 'Transaction';
  /** Эквайринг транзакции */
  acquiring?: Maybe<Acquiring>;
  /** Id эквайринга */
  acquiringId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Покупаемый блок */
  block?: Maybe<Block>;
  /** Id блока */
  blockId?: Maybe<Scalars['ID']['output']>;
  /** Покупаемый курс */
  course?: Maybe<Course>;
  /** Id курса */
  courseId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderNumber: Scalars['Float']['output'];
  status: TransactionStatus;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum TransactionStatus {
  Canceled = 'CANCELED',
  New = 'NEW',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Rejected = 'REJECTED',
  Succeeded = 'SUCCEEDED',
  WaitingForCapture = 'WAITING_FOR_CAPTURE'
}

export enum UnavailableReason {
  CourseNotPurchased = 'COURSE_NOT_PURCHASED',
  NotPurchased = 'NOT_PURCHASED',
  NotTrial = 'NOT_TRIAL',
  Progress = 'PROGRESS',
  TimeExpired = 'TIME_EXPIRED',
  TimeNotStarted = 'TIME_NOT_STARTED'
}

export type User = {
  __typename?: 'User';
  /** Записи истории изменений ответов */
  answersHistory?: Maybe<Array<UserAnswerHistory>>;
  /** Файл аватара пользователя */
  avatarFile?: Maybe<File>;
  /** ID файла аватара пользователя */
  avatarFileId?: Maybe<Scalars['ID']['output']>;
  /** Дата рождения пользователя */
  birthDate?: Maybe<Scalars['Date']['output']>;
  /** ID чата с ботом в telegram */
  botChatId?: Maybe<Scalars['Float']['output']>;
  /** Комментарий о пользователи внутри системы */
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Курсы куратора */
  curatorCourses?: Maybe<Array<CourseCurator>>;
  /** Имя пользователя */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Заблокирован ли пользователь */
  isBlocked: Scalars['Boolean']['output'];
  /** Фамилия пользователя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество пользователя */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Числовой ID пользователя */
  numericId: Scalars['Int']['output'];
  /** Значение номера телефона */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** `Рефреш`-токены пользователя */
  refreshTokens?: Maybe<Array<RefreshToken>>;
  /** Название роли */
  role: RoleName;
  /** ID пользователя из telegram */
  telegramId: Scalars['Float']['output'];
  /** Username пользоателя из телеграма */
  telegramUsername?: Maybe<Scalars['String']['output']>;
  /** Транзакции пользователя */
  transactions?: Maybe<Array<Transaction>>;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователя */
  userAnswers?: Maybe<Array<UserAnswer>>;
  /** Курсы пользователя */
  userCourses?: Maybe<Array<UserCourse>>;
  /** Прогрес пользователя по элементам */
  userProgresses?: Maybe<Array<UserProgress>>;
};

export type UserAnswer = {
  __typename?: 'UserAnswer';
  /** Ответ пользователя */
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Элемент */
  element: Element;
  /** ID элемента */
  elementId: Scalars['ID']['output'];
  /** Часть элемента */
  elementPart?: Maybe<ElementPart>;
  /** ID части элемента */
  elementPartId?: Maybe<Scalars['ID']['output']>;
  /** Файлы */
  files?: Maybe<Array<UserAnswerFile>>;
  /** История изменений ответа */
  history?: Maybe<Array<UserAnswerHistory>>;
  id: Scalars['ID']['output'];
  /** Ответ пользователя */
  status?: Maybe<UserAnswerStatus>;
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user: User;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

/** Файл, прикрепленный к ответу */
export type UserAnswerFile = {
  __typename?: 'UserAnswerFile';
  createdAt: Scalars['Date']['output'];
  /** Прикрепленный файл */
  file: File;
  /** ID прикрепленного файла */
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Ответ */
  userAnswer: UserAnswer;
  /** ID ответа */
  userAnswerId: Scalars['ID']['output'];
};

export type UserAnswerFileLkDto = {
  __typename?: 'UserAnswerFileLkDto';
  /** Прикрепленный файл */
  file: FileLkDto;
  id: Scalars['ID']['output'];
};

export type UserAnswerHistory = {
  __typename?: 'UserAnswerHistory';
  answer: UserAnswer;
  answerId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** Файлы истории */
  files?: Maybe<Array<UserAnswerHistoryFile>>;
  id: Scalars['ID']['output'];
  /** Сообщение */
  message?: Maybe<Scalars['String']['output']>;
  /** Новый статус */
  newStatus?: Maybe<UserAnswerStatus>;
  /** Проставленные баллы */
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserAnswerHistoryFile = {
  __typename?: 'UserAnswerHistoryFile';
  createdAt: Scalars['Date']['output'];
  /** Прикрепленный файл */
  file: File;
  /** ID прикрепленного файла */
  fileId: Scalars['ID']['output'];
  /** История изменений */
  history: UserAnswerHistory;
  /** ID истории */
  historyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UserAnswerHistoryFileLkDto = {
  __typename?: 'UserAnswerHistoryFileLkDto';
  /** Прикрепленный файл */
  file: FileLkDto;
  /** ID истории */
  historyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type UserAnswerHistoryLkDto = {
  __typename?: 'UserAnswerHistoryLkDto';
  /** Файлы истории */
  files?: Maybe<Array<UserAnswerHistoryFileLkDto>>;
  id: Scalars['ID']['output'];
  /** Сообщение */
  message?: Maybe<Scalars['String']['output']>;
  /** Новый статус */
  newStatus?: Maybe<UserAnswerStatus>;
  /** Проставленные баллы */
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user?: Maybe<PreviewUserLkDto>;
};

export type UserAnswerLkDto = {
  __typename?: 'UserAnswerLkDto';
  /** Ответ пользователя */
  answer?: Maybe<Scalars['String']['output']>;
  /** ID элемента */
  elementId: Scalars['ID']['output'];
  /** ID части элемента */
  elementPartId?: Maybe<Scalars['ID']['output']>;
  /** Файлы ответа */
  files?: Maybe<Array<UserAnswerFileLkDto>>;
  /** История изменений ответа */
  history?: Maybe<Array<UserAnswerHistoryLkDto>>;
  id: Scalars['ID']['output'];
  /** Ответ пользователя */
  status?: Maybe<UserAnswerStatus>;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export enum UserAnswerStatus {
  Autocomplete = 'AUTOCOMPLETE',
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  ReplyReceived = 'REPLY_RECEIVED'
}

export type UserBlock = {
  __typename?: 'UserBlock';
  /** Блок */
  block: Block;
  /** ID блока */
  blockId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Способ приобретения */
  type: UserBlockType;
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user: User;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export enum UserBlockType {
  Issued = 'ISSUED',
  Paid = 'PAID',
  Trial = 'TRIAL'
}

export type UserCourse = {
  __typename?: 'UserCourse';
  /** Курс */
  course: Course;
  /** ID курса */
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Тип доступа */
  type: UserCourseType;
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user: User;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export type UserCourseLkDto = {
  __typename?: 'UserCourseLkDto';
  /** ID курса */
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Тип доступа */
  type: UserCourseType;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export enum UserCourseType {
  Full = 'FULL',
  Partial = 'PARTIAL',
  Trial = 'TRIAL'
}

export type UserLkDto = {
  __typename?: 'UserLkDto';
  /** Файл аватара пользователя */
  avatarFile?: Maybe<FileLkDto>;
  /** Дата рождения пользователя */
  birthDate?: Maybe<Scalars['Date']['output']>;
  /** Комментарий о пользователи внутри системы */
  comment?: Maybe<Scalars['String']['output']>;
  /** Имя пользователя */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Есть ли у пользователя пароль */
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Фамилия пользователя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество пользователя */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Числовой ID пользователя */
  numericId: Scalars['Int']['output'];
  /** Значение номера телефона */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Инициализирован ли чат с ботом у пользователя */
  registerInBot: Scalars['Boolean']['output'];
  /** Название роли */
  role: RoleName;
  /** ID пользователя из telegram */
  telegramId: Scalars['Float']['output'];
  /** Username пользоателя из телеграма */
  telegramUsername?: Maybe<Scalars['String']['output']>;
};

export type UserProgress = {
  __typename?: 'UserProgress';
  createdAt: Scalars['Date']['output'];
  /** Элемент */
  element: Element;
  /** ID элемента */
  elementId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Положительный ли прогресс по элементу */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** Баллы полученные за элемент */
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user: User;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

export type UserProgressLkDto = {
  __typename?: 'UserProgressLkDto';
  /** ID элемента */
  elementId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Положительный ли прогресс по элементу */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** Баллы полученные за элемент */
  score?: Maybe<Scalars['Float']['output']>;
  /** ID пользователя */
  userId: Scalars['ID']['output'];
};

/** Видео элемент */
export type VideoElement = Element & {
  __typename?: 'VideoElement';
  createdAt: Scalars['Date']['output'];
  /** Части элементов */
  elementParts?: Maybe<Array<ElementPart>>;
  /** Задание, к которому привязан элемент */
  exercise: Exercise;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFile>>;
  id: Scalars['ID']['output'];
  /** ID видео на киноскопе */
  kinescopeId: Scalars['String']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
  updatedAt: Scalars['Date']['output'];
  /** Ответы пользователей */
  usersAnswers?: Maybe<Array<UserAnswer>>;
  /** Ответы пользователей */
  usersProgresses?: Maybe<Array<UserProgress>>;
};

export type VideoElementLkDto = ElementLkDto & {
  __typename?: 'VideoElementLkDto';
  /** Текущий прогресс пользователя по элементу */
  currentUserProgress?: Maybe<UserProgressLkDto>;
  /** Файлы элементов */
  elementParts?: Maybe<Array<ElementPartLkDto>>;
  /** ID задания */
  exerciseId: Scalars['ID']['output'];
  /** Файлы элементов */
  files?: Maybe<Array<ElementFileLkDto>>;
  id: Scalars['ID']['output'];
  /** ID видео на киноскопе */
  kinescopeId: Scalars['String']['output'];
  /** Порядковый номер элемента */
  order: Scalars['Int']['output'];
  /** Тип элемента */
  type: ElementType;
};

export type LoginByTelegramMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginByTelegramMutation = { __typename?: 'Mutation', loginByTelegram: { __typename?: 'AuthTokensDto', accessToken: string, refreshToken: string } };

export type LoginByTelegramTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginByTelegramTokenMutation = { __typename?: 'Mutation', loginByTelegramToken: { __typename?: 'AuthTokensDto', accessToken: string, refreshToken: string } };

export type BlockQueryVariables = Exact<{
  blockId: Scalars['ID']['input'];
}>;


export type BlockQuery = { __typename?: 'Query', block: { __typename?: 'BlockLkDto', id: string, courseId: string, isAvailable?: boolean | null, unavailableReason?: UnavailableReason | null, statistic?: { __typename?: 'ProgressStatistic', progress: number, homeworkScore: Array<{ __typename?: 'ScoreType', maxScore: number, score?: number | null }>, lectureScore: { __typename?: 'ScoreType', maxScore: number, score?: number | null } } | null, lessons?: Array<{ __typename?: 'LessonLkDto', id: string, title: string, dateTo?: any | null, dateFrom?: any | null, isAvailable?: boolean | null, unavailableReason?: UnavailableReason | null, hasFileAnswerQuestion: boolean, completeness?: { __typename?: 'CompletenessType', isComplete: boolean, isDone: boolean } | null, exercises?: Array<{ __typename?: 'ExerciseLkDto', id: string, title: string, type: ExerciseType, isAvailable?: boolean | null }> | null }> | null } };

export type CourseCardQueryVariables = Exact<{
  cardType: CourseCardType;
  courseId: Scalars['String']['input'];
}>;


export type CourseCardQuery = { __typename?: 'Query', courseCard: { __typename?: 'CourseCardLkDto', id: string, description: string, useDefaultCover: boolean, coverFile?: { __typename?: 'FileLkDto', url: string } | null, course: { __typename?: 'CoursePresentationLkDto', id: string, title?: string | null, subject: CourseSubject, description?: string | null, cost: number, grade: number, coverFile?: { __typename?: 'FileLkDto', url: string } | null } } };

export type CourseCardByIdQueryVariables = Exact<{
  courseCardId: Scalars['String']['input'];
}>;


export type CourseCardByIdQuery = { __typename?: 'Query', courseCardById?: { __typename?: 'CourseCardLkDto', id: string, link?: string | null, useDefaultCover: boolean, description: string, type: CourseCardType, course: { __typename?: 'CoursePresentationLkDto', id: string, subject: CourseSubject, title?: string | null, description?: string | null, coverFile?: { __typename?: 'FileLkDto', url: string } | null }, coverFile?: { __typename?: 'FileLkDto', url: string } | null } | null };

export type AvailableCourseCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCourseCardsQuery = { __typename?: 'Query', availableCourseCards: Array<{ __typename?: 'CourseCardLkDto', id: string, course: { __typename?: 'CoursePresentationLkDto', id: string } }> };

export type CardsQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type CardsQuery = { __typename?: 'Query', availableCourseCards: Array<{ __typename?: 'CourseCardLkDto', id: string, description: string, useDefaultCover: boolean, type: CourseCardType, link?: string | null, coverFile?: { __typename?: 'FileLkDto', url: string } | null, course: { __typename?: 'CoursePresentationLkDto', id: string, title?: string | null, subject: CourseSubject, coverFile?: { __typename?: 'FileLkDto', url: string } | null } }>, course: { __typename?: 'CourseLkDto', id: string, advertising?: Array<{ __typename?: 'CourseCardAdvertisingLkDto', id: string, card: { __typename?: 'CourseCardLkDto', id: string, description: string, useDefaultCover: boolean, type: CourseCardType, link?: string | null, coverFile?: { __typename?: 'FileLkDto', url: string } | null, course: { __typename?: 'CoursePresentationLkDto', id: string, title?: string | null, subject: CourseSubject, coverFile?: { __typename?: 'FileLkDto', url: string } | null } } }> | null } };

export type CourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type CourseQuery = { __typename?: 'Query', course: { __typename?: 'CourseLkDto', id: string, title?: string | null, subject: CourseSubject, userCourse?: { __typename?: 'UserCourseLkDto', id: string, type: UserCourseType } | null, blocks?: Array<{ __typename?: 'BlockLkDto', id: string, isAvailable?: boolean | null, availabilityType: BlockAvailabilityType, unavailableReason?: UnavailableReason | null, title: string, coverFile?: { __typename?: 'FileLkDto', url: string } | null, statistic?: { __typename?: 'ProgressStatistic', progress: number, lessonsCount: { __typename?: 'CountType', completeCount: number, totalCount: number } } | null }> | null }, courseStatistic: { __typename?: 'ProgressStatistic', progress: number } };

export type CourseStatisticQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type CourseStatisticQuery = { __typename?: 'Query', courseStatistic: { __typename?: 'ProgressStatistic', homeworkScore: Array<{ __typename?: 'ScoreType', maxScore: number, score?: number | null }>, lectureScore: { __typename?: 'ScoreType', maxScore: number, score?: number | null } } };

export type GetCourseThemeQueryVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type GetCourseThemeQuery = { __typename?: 'Query', courseCard: { __typename?: 'CourseCardLkDto', id: string, course: { __typename?: 'CoursePresentationLkDto', subject: CourseSubject, colorTheme?: { __typename?: 'ColorThemeLkDto', id: string, color: string } | null } } };

export type CommitProgressMutationVariables = Exact<{
  exerciseId: Scalars['ID']['input'];
}>;


export type CommitProgressMutation = { __typename?: 'Mutation', commitProgress: boolean };

export type CreateAnswerFeedbackMutationVariables = Exact<{
  input: CreateAnswerFeedbackInput;
}>;


export type CreateAnswerFeedbackMutation = { __typename?: 'Mutation', createAnswerFeedback?: { __typename?: 'UserAnswerLkDto', id: string, history?: Array<{ __typename?: 'UserAnswerHistoryLkDto', id: string, updatedAt: any, message?: string | null, score?: number | null, newStatus?: UserAnswerStatus | null, files?: Array<{ __typename?: 'UserAnswerHistoryFileLkDto', id: string, file: { __typename?: 'FileLkDto', url: string, name: string } }> | null, user?: { __typename?: 'PreviewUserLkDto', id: string, firstName?: string | null, lastName?: string | null } | null }> | null } | null };

export type CreateSingleProgressMutationVariables = Exact<{
  elementId: Scalars['ID']['input'];
}>;


export type CreateSingleProgressMutation = { __typename?: 'Mutation', createSingleProgress: { __typename?: 'UserProgressLkDto', id: string, isCorrect?: boolean | null, score?: number | null } };

export type CreateUserAnswerMutationVariables = Exact<{
  input: CreateUserAnswerInput;
}>;


export type CreateUserAnswerMutation = { __typename?: 'Mutation', createUserAnswer: Array<{ __typename?: 'UserAnswerLkDto', id: string, answer?: string | null, status?: UserAnswerStatus | null, files?: Array<{ __typename?: 'UserAnswerFileLkDto', id: string, file: { __typename?: 'FileLkDto', name: string, url: string } }> | null }> };

export type ExerciseQueryVariables = Exact<{
  exerciseId: Scalars['ID']['input'];
}>;


export type ExerciseQuery = { __typename?: 'Query', exercise: { __typename?: 'ExerciseLkDto', id: string, title: string, type: ExerciseType, completeness?: { __typename?: 'CompletenessType', isComplete: boolean, isDone: boolean } | null, userStatistic?: { __typename?: 'ExerciseStatistic', maxScoreA?: number | null, maxScoreB?: number | null, scoreA?: number | null, scoreB?: number | null } | null, elements?: Array<{ __typename?: 'ExerciseLinkElementLkDto', description?: string | null, id: string, type: ElementType, order: number } | { __typename?: 'FeedbackElementLkDto', id: string, type: ElementType, order: number, elementParts?: Array<{ __typename?: 'ElementPartLkDto', content?: string | null }> | null } | { __typename?: 'FileElementLkDto', id: string, type: ElementType, order: number, files?: Array<{ __typename?: 'ElementFileLkDto', id: string, type: ElementFileType, file: { __typename?: 'FileLkDto', name: string, url: string } }> | null } | { __typename?: 'HeadingElementLkDto', title?: string | null, id: string, type: ElementType, order: number } | { __typename?: 'QuestionElementLkDto', questionType: QuestionType, title?: string | null, description?: string | null, placeholder?: string | null, matchingAnswers?: Array<string> | null, id: string, type: ElementType, order: number, elementParts?: Array<{ __typename?: 'ElementPartLkDto', id: string, content?: string | null }> | null, currentUserProgress?: { __typename?: 'UserProgressLkDto', isCorrect?: boolean | null, score?: number | null } | null, correctAnswers?: Array<{ __typename?: 'FullElementPartLkDto', isCorrect?: boolean | null, content?: string | null, correctAnswer?: string | null, order?: number | null, id: string }> | null, currentUserAnswers?: Array<{ __typename?: 'UserAnswerLkDto', answer?: string | null, id: string, status?: UserAnswerStatus | null, elementPartId?: string | null, files?: Array<{ __typename?: 'UserAnswerFileLkDto', id: string, file: { __typename?: 'FileLkDto', name: string, url: string } }> | null, history?: Array<{ __typename?: 'UserAnswerHistoryLkDto', id: string, updatedAt: any, message?: string | null, score?: number | null, newStatus?: UserAnswerStatus | null, files?: Array<{ __typename?: 'UserAnswerHistoryFileLkDto', id: string, file: { __typename?: 'FileLkDto', url: string, name: string } }> | null, user?: { __typename?: 'PreviewUserLkDto', id: string, firstName?: string | null, lastName?: string | null } | null }> | null }> | null, files?: Array<{ __typename?: 'ElementFileLkDto', id: string, fileName: string, file: { __typename?: 'FileLkDto', name: string, url: string } }> | null } | { __typename?: 'TextElementLkDto', content: string, id: string, type: ElementType, order: number } | { __typename?: 'VideoElementLkDto', kinescopeId: string, id: string, type: ElementType, order: number }> | null } };

export type GetHomeworkResultQueryVariables = Exact<{
  exerciseId: Scalars['ID']['input'];
}>;


export type GetHomeworkResultQuery = { __typename?: 'Query', exercise: { __typename?: 'ExerciseLkDto', id: string, title: string, type: ExerciseType, userStatistic?: { __typename?: 'ExerciseStatistic', maxScoreA?: number | null, maxScoreB?: number | null, scoreA?: number | null, scoreB?: number | null } | null, completeness?: { __typename?: 'CompletenessType', isComplete: boolean, isDone: boolean } | null, elements?: Array<{ __typename?: 'ExerciseLinkElementLkDto', id: string, type: ElementType, order: number } | { __typename?: 'FeedbackElementLkDto', id: string, type: ElementType, order: number } | { __typename?: 'FileElementLkDto', id: string, type: ElementType, order: number } | { __typename?: 'HeadingElementLkDto', id: string, type: ElementType, order: number } | { __typename?: 'QuestionElementLkDto', questionType: QuestionType, id: string, type: ElementType, order: number, currentUserProgress?: { __typename?: 'UserProgressLkDto', isCorrect?: boolean | null } | null, correctAnswers?: Array<{ __typename?: 'FullElementPartLkDto', content?: string | null, correctAnswer?: string | null, isCorrect?: boolean | null }> | null, currentUserAnswers?: Array<{ __typename?: 'UserAnswerLkDto', id: string, answer?: string | null, status?: UserAnswerStatus | null }> | null } | { __typename?: 'TextElementLkDto', id: string, type: ElementType, order: number } | { __typename?: 'VideoElementLkDto', id: string, type: ElementType, order: number }> | null } };

export type GetLessonsQueryVariables = Exact<{
  blockId: Scalars['ID']['input'];
}>;


export type GetLessonsQuery = { __typename?: 'Query', block: { __typename?: 'BlockLkDto', id: string, lessons?: Array<{ __typename?: 'LessonLkDto', id: string, isAvailable?: boolean | null, exercises?: Array<{ __typename?: 'ExerciseLkDto', id: string, isAvailable?: boolean | null }> | null }> | null } };

export type LessonQueryVariables = Exact<{
  lessonId: Scalars['ID']['input'];
}>;


export type LessonQuery = { __typename?: 'Query', lesson: { __typename?: 'LessonLkDto', id: string, hasFileAnswerQuestion: boolean, dateTo?: any | null, completeness?: { __typename?: 'CompletenessType', isComplete: boolean, isDone: boolean } | null, exercises?: Array<{ __typename?: 'ExerciseLkDto', id: string, title: string, type: ExerciseType, isAvailable?: boolean | null, dateTo?: any | null, completeness?: { __typename?: 'CompletenessType', isDone: boolean, isComplete: boolean } | null }> | null } };

export type OnboardingCourseCardsQueryVariables = Exact<{
  grade?: InputMaybe<Scalars['Float']['input']>;
  subject?: InputMaybe<CourseSubject>;
}>;


export type OnboardingCourseCardsQuery = { __typename?: 'Query', onboardingCourseCards: Array<{ __typename?: 'CourseCardLkDto', id: string, useDefaultCover: boolean, coverFile?: { __typename?: 'FileLkDto', url: string } | null, course: { __typename?: 'CoursePresentationLkDto', id: string, title?: string | null, grade: number, subject: CourseSubject, coverFile?: { __typename?: 'FileLkDto', url: string } | null } }> };

export type BlockPresentationQueryVariables = Exact<{
  blockId: Scalars['ID']['input'];
}>;


export type BlockPresentationQuery = { __typename?: 'Query', blockPresentation?: { __typename?: 'BlockPresentationLkDto', id: string, title: string, cost: number } | null };

export type GetTrialMutationVariables = Exact<{
  coursesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetTrialMutation = { __typename?: 'Mutation', getTrial: boolean };

export type InitPaymentMutationVariables = Exact<{
  input: InitResourcePurchaseInput;
  receiptEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitPaymentMutation = { __typename?: 'Mutation', initPayment: string };

export type SendFileInChatBotMutationVariables = Exact<{
  elementFileId: Scalars['ID']['input'];
}>;


export type SendFileInChatBotMutation = { __typename?: 'Mutation', sendFileInChatBot: boolean };

export type SetUserCommentMutationVariables = Exact<{
  comment: Scalars['String']['input'];
}>;


export type SetUserCommentMutation = { __typename?: 'Mutation', setUserComment: boolean };

export type UpdateUserDataMutationVariables = Exact<{
  input: SelfUpdateUserDataInput;
}>;


export type UpdateUserDataMutation = { __typename?: 'Mutation', updateUserData: { __typename?: 'UserLkDto', id: string, birthDate?: any | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, phoneNumber?: string | null, telegramUsername?: string | null, comment?: string | null, avatarFile?: { __typename?: 'FileLkDto', url: string } | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'UserLkDto', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, registerInBot: boolean, telegramUsername?: string | null } };

export type UserCourseCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCourseCardsQuery = { __typename?: 'Query', availableCourseCards: Array<{ __typename?: 'CourseCardLkDto', id: string, description: string, useDefaultCover: boolean, type: CourseCardType, link?: string | null, coverFile?: { __typename?: 'FileLkDto', url: string } | null, course: { __typename?: 'CoursePresentationLkDto', id: string, title?: string | null, subject: CourseSubject, coverFile?: { __typename?: 'FileLkDto', url: string } | null } }>, userAdvertisingCourseCard?: Array<{ __typename?: 'CourseCardLkDto', id: string, description: string, useDefaultCover: boolean, type: CourseCardType, link?: string | null, coverFile?: { __typename?: 'FileLkDto', url: string } | null, course: { __typename?: 'CoursePresentationLkDto', id: string, title?: string | null, subject: CourseSubject, coverFile?: { __typename?: 'FileLkDto', url: string } | null } }> | null };

export type UserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileQuery = { __typename?: 'Query', me: { __typename?: 'UserLkDto', id: string, birthDate?: any | null, lastName?: string | null, firstName?: string | null, middleName?: string | null, phoneNumber?: string | null, telegramUsername?: string | null, comment?: string | null, avatarFile?: { __typename?: 'FileLkDto', url: string } | null } };


export const LoginByTelegramDocument = gql`
    mutation loginByTelegram($token: String!) {
  loginByTelegram(token: $token) {
    accessToken
    refreshToken
  }
}
    `;
export type LoginByTelegramMutationFn = Apollo.MutationFunction<LoginByTelegramMutation, LoginByTelegramMutationVariables>;

/**
 * __useLoginByTelegramMutation__
 *
 * To run a mutation, you first call `useLoginByTelegramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginByTelegramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginByTelegramMutation, { data, loading, error }] = useLoginByTelegramMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginByTelegramMutation(baseOptions?: Apollo.MutationHookOptions<LoginByTelegramMutation, LoginByTelegramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginByTelegramMutation, LoginByTelegramMutationVariables>(LoginByTelegramDocument, options);
      }
export type LoginByTelegramMutationHookResult = ReturnType<typeof useLoginByTelegramMutation>;
export type LoginByTelegramMutationResult = Apollo.MutationResult<LoginByTelegramMutation>;
export type LoginByTelegramMutationOptions = Apollo.BaseMutationOptions<LoginByTelegramMutation, LoginByTelegramMutationVariables>;
export const LoginByTelegramTokenDocument = gql`
    mutation loginByTelegramToken($token: String!) {
  loginByTelegramToken(token: $token) {
    accessToken
    refreshToken
  }
}
    `;
export type LoginByTelegramTokenMutationFn = Apollo.MutationFunction<LoginByTelegramTokenMutation, LoginByTelegramTokenMutationVariables>;

/**
 * __useLoginByTelegramTokenMutation__
 *
 * To run a mutation, you first call `useLoginByTelegramTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginByTelegramTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginByTelegramTokenMutation, { data, loading, error }] = useLoginByTelegramTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginByTelegramTokenMutation(baseOptions?: Apollo.MutationHookOptions<LoginByTelegramTokenMutation, LoginByTelegramTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginByTelegramTokenMutation, LoginByTelegramTokenMutationVariables>(LoginByTelegramTokenDocument, options);
      }
export type LoginByTelegramTokenMutationHookResult = ReturnType<typeof useLoginByTelegramTokenMutation>;
export type LoginByTelegramTokenMutationResult = Apollo.MutationResult<LoginByTelegramTokenMutation>;
export type LoginByTelegramTokenMutationOptions = Apollo.BaseMutationOptions<LoginByTelegramTokenMutation, LoginByTelegramTokenMutationVariables>;
export const BlockDocument = gql`
    query block($blockId: ID!) {
  block(blockId: $blockId) {
    id
    courseId
    isAvailable
    unavailableReason
    statistic {
      progress
      homeworkScore {
        maxScore
        score
      }
      lectureScore {
        maxScore
        score
      }
    }
    lessons {
      id
      title
      dateTo
      dateFrom
      isAvailable
      unavailableReason
      hasFileAnswerQuestion
      completeness {
        isComplete
        isDone
      }
      exercises {
        id
        title
        type
        isAvailable
      }
    }
  }
}
    `;

/**
 * __useBlockQuery__
 *
 * To run a query within a React component, call `useBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useBlockQuery(baseOptions: Apollo.QueryHookOptions<BlockQuery, BlockQueryVariables> & ({ variables: BlockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockQuery, BlockQueryVariables>(BlockDocument, options);
      }
export function useBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockQuery, BlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockQuery, BlockQueryVariables>(BlockDocument, options);
        }
export function useBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BlockQuery, BlockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockQuery, BlockQueryVariables>(BlockDocument, options);
        }
export type BlockQueryHookResult = ReturnType<typeof useBlockQuery>;
export type BlockLazyQueryHookResult = ReturnType<typeof useBlockLazyQuery>;
export type BlockSuspenseQueryHookResult = ReturnType<typeof useBlockSuspenseQuery>;
export type BlockQueryResult = Apollo.QueryResult<BlockQuery, BlockQueryVariables>;
export const CourseCardDocument = gql`
    query courseCard($cardType: CourseCardType!, $courseId: String!) {
  courseCard(courseId: $courseId, cardType: $cardType) {
    id
    coverFile {
      url
    }
    description
    useDefaultCover
    course {
      id
      title
      subject
      description
      cost
      grade
      coverFile {
        url
      }
    }
  }
}
    `;

/**
 * __useCourseCardQuery__
 *
 * To run a query within a React component, call `useCourseCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseCardQuery({
 *   variables: {
 *      cardType: // value for 'cardType'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseCardQuery(baseOptions: Apollo.QueryHookOptions<CourseCardQuery, CourseCardQueryVariables> & ({ variables: CourseCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseCardQuery, CourseCardQueryVariables>(CourseCardDocument, options);
      }
export function useCourseCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCardQuery, CourseCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseCardQuery, CourseCardQueryVariables>(CourseCardDocument, options);
        }
export function useCourseCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseCardQuery, CourseCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseCardQuery, CourseCardQueryVariables>(CourseCardDocument, options);
        }
export type CourseCardQueryHookResult = ReturnType<typeof useCourseCardQuery>;
export type CourseCardLazyQueryHookResult = ReturnType<typeof useCourseCardLazyQuery>;
export type CourseCardSuspenseQueryHookResult = ReturnType<typeof useCourseCardSuspenseQuery>;
export type CourseCardQueryResult = Apollo.QueryResult<CourseCardQuery, CourseCardQueryVariables>;
export const CourseCardByIdDocument = gql`
    query courseCardById($courseCardId: String!) {
  courseCardById(courseCardId: $courseCardId) {
    id
    link
    course {
      id
      subject
      title
      description
      coverFile {
        url
      }
    }
    useDefaultCover
    description
    coverFile {
      url
    }
    type
  }
}
    `;

/**
 * __useCourseCardByIdQuery__
 *
 * To run a query within a React component, call `useCourseCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseCardByIdQuery({
 *   variables: {
 *      courseCardId: // value for 'courseCardId'
 *   },
 * });
 */
export function useCourseCardByIdQuery(baseOptions: Apollo.QueryHookOptions<CourseCardByIdQuery, CourseCardByIdQueryVariables> & ({ variables: CourseCardByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseCardByIdQuery, CourseCardByIdQueryVariables>(CourseCardByIdDocument, options);
      }
export function useCourseCardByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCardByIdQuery, CourseCardByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseCardByIdQuery, CourseCardByIdQueryVariables>(CourseCardByIdDocument, options);
        }
export function useCourseCardByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseCardByIdQuery, CourseCardByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseCardByIdQuery, CourseCardByIdQueryVariables>(CourseCardByIdDocument, options);
        }
export type CourseCardByIdQueryHookResult = ReturnType<typeof useCourseCardByIdQuery>;
export type CourseCardByIdLazyQueryHookResult = ReturnType<typeof useCourseCardByIdLazyQuery>;
export type CourseCardByIdSuspenseQueryHookResult = ReturnType<typeof useCourseCardByIdSuspenseQuery>;
export type CourseCardByIdQueryResult = Apollo.QueryResult<CourseCardByIdQuery, CourseCardByIdQueryVariables>;
export const AvailableCourseCardsDocument = gql`
    query availableCourseCards {
  availableCourseCards {
    id
    course {
      id
    }
  }
}
    `;

/**
 * __useAvailableCourseCardsQuery__
 *
 * To run a query within a React component, call `useAvailableCourseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCourseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCourseCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableCourseCardsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableCourseCardsQuery, AvailableCourseCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCourseCardsQuery, AvailableCourseCardsQueryVariables>(AvailableCourseCardsDocument, options);
      }
export function useAvailableCourseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCourseCardsQuery, AvailableCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCourseCardsQuery, AvailableCourseCardsQueryVariables>(AvailableCourseCardsDocument, options);
        }
export function useAvailableCourseCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableCourseCardsQuery, AvailableCourseCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableCourseCardsQuery, AvailableCourseCardsQueryVariables>(AvailableCourseCardsDocument, options);
        }
export type AvailableCourseCardsQueryHookResult = ReturnType<typeof useAvailableCourseCardsQuery>;
export type AvailableCourseCardsLazyQueryHookResult = ReturnType<typeof useAvailableCourseCardsLazyQuery>;
export type AvailableCourseCardsSuspenseQueryHookResult = ReturnType<typeof useAvailableCourseCardsSuspenseQuery>;
export type AvailableCourseCardsQueryResult = Apollo.QueryResult<AvailableCourseCardsQuery, AvailableCourseCardsQueryVariables>;
export const CardsDocument = gql`
    query cards($courseId: ID!) {
  availableCourseCards {
    id
    description
    useDefaultCover
    type
    coverFile {
      url
    }
    course {
      id
      title
      subject
      coverFile {
        url
      }
    }
    link
  }
  course(courseId: $courseId) {
    id
    advertising {
      id
      card {
        id
        description
        useDefaultCover
        type
        coverFile {
          url
        }
        course {
          id
          title
          subject
          coverFile {
            url
          }
        }
        link
      }
    }
  }
}
    `;

/**
 * __useCardsQuery__
 *
 * To run a query within a React component, call `useCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCardsQuery(baseOptions: Apollo.QueryHookOptions<CardsQuery, CardsQueryVariables> & ({ variables: CardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardsQuery, CardsQueryVariables>(CardsDocument, options);
      }
export function useCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardsQuery, CardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardsQuery, CardsQueryVariables>(CardsDocument, options);
        }
export function useCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CardsQuery, CardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardsQuery, CardsQueryVariables>(CardsDocument, options);
        }
export type CardsQueryHookResult = ReturnType<typeof useCardsQuery>;
export type CardsLazyQueryHookResult = ReturnType<typeof useCardsLazyQuery>;
export type CardsSuspenseQueryHookResult = ReturnType<typeof useCardsSuspenseQuery>;
export type CardsQueryResult = Apollo.QueryResult<CardsQuery, CardsQueryVariables>;
export const CourseDocument = gql`
    query course($courseId: ID!) {
  course(courseId: $courseId) {
    id
    title
    subject
    userCourse {
      id
      type
    }
    blocks {
      id
      isAvailable
      availabilityType
      unavailableReason
      coverFile {
        url
      }
      title
      statistic {
        progress
        lessonsCount {
          completeCount
          totalCount
        }
      }
    }
  }
  courseStatistic(courseId: $courseId) {
    progress
  }
}
    `;

/**
 * __useCourseQuery__
 *
 * To run a query within a React component, call `useCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseQuery(baseOptions: Apollo.QueryHookOptions<CourseQuery, CourseQueryVariables> & ({ variables: CourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
      }
export function useCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseQuery, CourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
        }
export function useCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseQuery, CourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
        }
export type CourseQueryHookResult = ReturnType<typeof useCourseQuery>;
export type CourseLazyQueryHookResult = ReturnType<typeof useCourseLazyQuery>;
export type CourseSuspenseQueryHookResult = ReturnType<typeof useCourseSuspenseQuery>;
export type CourseQueryResult = Apollo.QueryResult<CourseQuery, CourseQueryVariables>;
export const CourseStatisticDocument = gql`
    query courseStatistic($courseId: ID!) {
  courseStatistic(courseId: $courseId) {
    homeworkScore {
      maxScore
      score
    }
    lectureScore {
      maxScore
      score
    }
  }
}
    `;

/**
 * __useCourseStatisticQuery__
 *
 * To run a query within a React component, call `useCourseStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseStatisticQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseStatisticQuery(baseOptions: Apollo.QueryHookOptions<CourseStatisticQuery, CourseStatisticQueryVariables> & ({ variables: CourseStatisticQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseStatisticQuery, CourseStatisticQueryVariables>(CourseStatisticDocument, options);
      }
export function useCourseStatisticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseStatisticQuery, CourseStatisticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseStatisticQuery, CourseStatisticQueryVariables>(CourseStatisticDocument, options);
        }
export function useCourseStatisticSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseStatisticQuery, CourseStatisticQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseStatisticQuery, CourseStatisticQueryVariables>(CourseStatisticDocument, options);
        }
export type CourseStatisticQueryHookResult = ReturnType<typeof useCourseStatisticQuery>;
export type CourseStatisticLazyQueryHookResult = ReturnType<typeof useCourseStatisticLazyQuery>;
export type CourseStatisticSuspenseQueryHookResult = ReturnType<typeof useCourseStatisticSuspenseQuery>;
export type CourseStatisticQueryResult = Apollo.QueryResult<CourseStatisticQuery, CourseStatisticQueryVariables>;
export const GetCourseThemeDocument = gql`
    query getCourseTheme($courseId: String!) {
  courseCard(courseId: $courseId, cardType: ONBOARDING) {
    id
    course {
      subject
      colorTheme {
        id
        color
      }
    }
  }
}
    `;

/**
 * __useGetCourseThemeQuery__
 *
 * To run a query within a React component, call `useGetCourseThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseThemeQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseThemeQuery(baseOptions: Apollo.QueryHookOptions<GetCourseThemeQuery, GetCourseThemeQueryVariables> & ({ variables: GetCourseThemeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseThemeQuery, GetCourseThemeQueryVariables>(GetCourseThemeDocument, options);
      }
export function useGetCourseThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseThemeQuery, GetCourseThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseThemeQuery, GetCourseThemeQueryVariables>(GetCourseThemeDocument, options);
        }
export function useGetCourseThemeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseThemeQuery, GetCourseThemeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseThemeQuery, GetCourseThemeQueryVariables>(GetCourseThemeDocument, options);
        }
export type GetCourseThemeQueryHookResult = ReturnType<typeof useGetCourseThemeQuery>;
export type GetCourseThemeLazyQueryHookResult = ReturnType<typeof useGetCourseThemeLazyQuery>;
export type GetCourseThemeSuspenseQueryHookResult = ReturnType<typeof useGetCourseThemeSuspenseQuery>;
export type GetCourseThemeQueryResult = Apollo.QueryResult<GetCourseThemeQuery, GetCourseThemeQueryVariables>;
export const CommitProgressDocument = gql`
    mutation commitProgress($exerciseId: ID!) {
  commitProgress(exerciseId: $exerciseId)
}
    `;
export type CommitProgressMutationFn = Apollo.MutationFunction<CommitProgressMutation, CommitProgressMutationVariables>;

/**
 * __useCommitProgressMutation__
 *
 * To run a mutation, you first call `useCommitProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitProgressMutation, { data, loading, error }] = useCommitProgressMutation({
 *   variables: {
 *      exerciseId: // value for 'exerciseId'
 *   },
 * });
 */
export function useCommitProgressMutation(baseOptions?: Apollo.MutationHookOptions<CommitProgressMutation, CommitProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitProgressMutation, CommitProgressMutationVariables>(CommitProgressDocument, options);
      }
export type CommitProgressMutationHookResult = ReturnType<typeof useCommitProgressMutation>;
export type CommitProgressMutationResult = Apollo.MutationResult<CommitProgressMutation>;
export type CommitProgressMutationOptions = Apollo.BaseMutationOptions<CommitProgressMutation, CommitProgressMutationVariables>;
export const CreateAnswerFeedbackDocument = gql`
    mutation createAnswerFeedback($input: CreateAnswerFeedbackInput!) {
  createAnswerFeedback(input: $input) {
    id
    history {
      id
      updatedAt
      message
      score
      newStatus
      files {
        id
        file {
          url
          name
        }
      }
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type CreateAnswerFeedbackMutationFn = Apollo.MutationFunction<CreateAnswerFeedbackMutation, CreateAnswerFeedbackMutationVariables>;

/**
 * __useCreateAnswerFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateAnswerFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerFeedbackMutation, { data, loading, error }] = useCreateAnswerFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnswerFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnswerFeedbackMutation, CreateAnswerFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnswerFeedbackMutation, CreateAnswerFeedbackMutationVariables>(CreateAnswerFeedbackDocument, options);
      }
export type CreateAnswerFeedbackMutationHookResult = ReturnType<typeof useCreateAnswerFeedbackMutation>;
export type CreateAnswerFeedbackMutationResult = Apollo.MutationResult<CreateAnswerFeedbackMutation>;
export type CreateAnswerFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateAnswerFeedbackMutation, CreateAnswerFeedbackMutationVariables>;
export const CreateSingleProgressDocument = gql`
    mutation createSingleProgress($elementId: ID!) {
  createSingleProgress(elementId: $elementId) {
    id
    isCorrect
    score
  }
}
    `;
export type CreateSingleProgressMutationFn = Apollo.MutationFunction<CreateSingleProgressMutation, CreateSingleProgressMutationVariables>;

/**
 * __useCreateSingleProgressMutation__
 *
 * To run a mutation, you first call `useCreateSingleProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleProgressMutation, { data, loading, error }] = useCreateSingleProgressMutation({
 *   variables: {
 *      elementId: // value for 'elementId'
 *   },
 * });
 */
export function useCreateSingleProgressMutation(baseOptions?: Apollo.MutationHookOptions<CreateSingleProgressMutation, CreateSingleProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSingleProgressMutation, CreateSingleProgressMutationVariables>(CreateSingleProgressDocument, options);
      }
export type CreateSingleProgressMutationHookResult = ReturnType<typeof useCreateSingleProgressMutation>;
export type CreateSingleProgressMutationResult = Apollo.MutationResult<CreateSingleProgressMutation>;
export type CreateSingleProgressMutationOptions = Apollo.BaseMutationOptions<CreateSingleProgressMutation, CreateSingleProgressMutationVariables>;
export const CreateUserAnswerDocument = gql`
    mutation createUserAnswer($input: CreateUserAnswerInput!) {
  createUserAnswer(input: $input) {
    id
    answer
    status
    files {
      id
      file {
        name
        url
      }
    }
  }
}
    `;
export type CreateUserAnswerMutationFn = Apollo.MutationFunction<CreateUserAnswerMutation, CreateUserAnswerMutationVariables>;

/**
 * __useCreateUserAnswerMutation__
 *
 * To run a mutation, you first call `useCreateUserAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAnswerMutation, { data, loading, error }] = useCreateUserAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserAnswerMutation, CreateUserAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserAnswerMutation, CreateUserAnswerMutationVariables>(CreateUserAnswerDocument, options);
      }
export type CreateUserAnswerMutationHookResult = ReturnType<typeof useCreateUserAnswerMutation>;
export type CreateUserAnswerMutationResult = Apollo.MutationResult<CreateUserAnswerMutation>;
export type CreateUserAnswerMutationOptions = Apollo.BaseMutationOptions<CreateUserAnswerMutation, CreateUserAnswerMutationVariables>;
export const ExerciseDocument = gql`
    query exercise($exerciseId: ID!) {
  exercise(exerciseId: $exerciseId) {
    id
    title
    type
    completeness {
      isComplete
      isDone
    }
    userStatistic {
      maxScoreA
      maxScoreB
      scoreA
      scoreB
    }
    elements {
      id
      type
      order
      ... on HeadingElementLkDto {
        title
      }
      ... on FeedbackElementLkDto {
        elementParts {
          content
        }
      }
      ... on VideoElementLkDto {
        kinescopeId
      }
      ... on TextElementLkDto {
        content
      }
      ... on QuestionElementLkDto {
        questionType
        title
        description
        placeholder
        matchingAnswers
        elementParts {
          id
          content
        }
        currentUserProgress {
          isCorrect
          score
        }
        correctAnswers {
          isCorrect
          content
          correctAnswer
          order
          id
        }
        currentUserAnswers {
          answer
          id
          status
          elementPartId
          files {
            id
            file {
              name
              url
            }
          }
          history {
            id
            updatedAt
            message
            score
            newStatus
            files {
              id
              file {
                url
                name
              }
            }
            user {
              id
              firstName
              lastName
            }
          }
          files {
            id
            file {
              url
              name
            }
          }
        }
        files {
          id
          fileName
          file {
            name
            url
          }
        }
      }
      ... on FileElementLkDto {
        files {
          id
          type
          file {
            name
            url
          }
        }
      }
      ... on ExerciseLinkElementLkDto {
        description
      }
    }
  }
}
    `;

/**
 * __useExerciseQuery__
 *
 * To run a query within a React component, call `useExerciseQuery` and pass it any options that fit your needs.
 * When your component renders, `useExerciseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExerciseQuery({
 *   variables: {
 *      exerciseId: // value for 'exerciseId'
 *   },
 * });
 */
export function useExerciseQuery(baseOptions: Apollo.QueryHookOptions<ExerciseQuery, ExerciseQueryVariables> & ({ variables: ExerciseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExerciseQuery, ExerciseQueryVariables>(ExerciseDocument, options);
      }
export function useExerciseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExerciseQuery, ExerciseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExerciseQuery, ExerciseQueryVariables>(ExerciseDocument, options);
        }
export function useExerciseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExerciseQuery, ExerciseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExerciseQuery, ExerciseQueryVariables>(ExerciseDocument, options);
        }
export type ExerciseQueryHookResult = ReturnType<typeof useExerciseQuery>;
export type ExerciseLazyQueryHookResult = ReturnType<typeof useExerciseLazyQuery>;
export type ExerciseSuspenseQueryHookResult = ReturnType<typeof useExerciseSuspenseQuery>;
export type ExerciseQueryResult = Apollo.QueryResult<ExerciseQuery, ExerciseQueryVariables>;
export const GetHomeworkResultDocument = gql`
    query getHomeworkResult($exerciseId: ID!) {
  exercise(exerciseId: $exerciseId) {
    id
    title
    type
    userStatistic {
      maxScoreA
      maxScoreB
      scoreA
      scoreB
    }
    completeness {
      isComplete
      isDone
    }
    elements {
      id
      type
      order
      ... on QuestionElementLkDto {
        questionType
        currentUserProgress {
          isCorrect
        }
        correctAnswers {
          content
          correctAnswer
          isCorrect
        }
        currentUserAnswers {
          id
          answer
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetHomeworkResultQuery__
 *
 * To run a query within a React component, call `useGetHomeworkResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeworkResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeworkResultQuery({
 *   variables: {
 *      exerciseId: // value for 'exerciseId'
 *   },
 * });
 */
export function useGetHomeworkResultQuery(baseOptions: Apollo.QueryHookOptions<GetHomeworkResultQuery, GetHomeworkResultQueryVariables> & ({ variables: GetHomeworkResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeworkResultQuery, GetHomeworkResultQueryVariables>(GetHomeworkResultDocument, options);
      }
export function useGetHomeworkResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeworkResultQuery, GetHomeworkResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeworkResultQuery, GetHomeworkResultQueryVariables>(GetHomeworkResultDocument, options);
        }
export function useGetHomeworkResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomeworkResultQuery, GetHomeworkResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeworkResultQuery, GetHomeworkResultQueryVariables>(GetHomeworkResultDocument, options);
        }
export type GetHomeworkResultQueryHookResult = ReturnType<typeof useGetHomeworkResultQuery>;
export type GetHomeworkResultLazyQueryHookResult = ReturnType<typeof useGetHomeworkResultLazyQuery>;
export type GetHomeworkResultSuspenseQueryHookResult = ReturnType<typeof useGetHomeworkResultSuspenseQuery>;
export type GetHomeworkResultQueryResult = Apollo.QueryResult<GetHomeworkResultQuery, GetHomeworkResultQueryVariables>;
export const GetLessonsDocument = gql`
    query getLessons($blockId: ID!) {
  block(blockId: $blockId) {
    id
    lessons {
      id
      isAvailable
      exercises {
        id
        isAvailable
      }
    }
  }
}
    `;

/**
 * __useGetLessonsQuery__
 *
 * To run a query within a React component, call `useGetLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonsQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useGetLessonsQuery(baseOptions: Apollo.QueryHookOptions<GetLessonsQuery, GetLessonsQueryVariables> & ({ variables: GetLessonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonsQuery, GetLessonsQueryVariables>(GetLessonsDocument, options);
      }
export function useGetLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonsQuery, GetLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonsQuery, GetLessonsQueryVariables>(GetLessonsDocument, options);
        }
export function useGetLessonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLessonsQuery, GetLessonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonsQuery, GetLessonsQueryVariables>(GetLessonsDocument, options);
        }
export type GetLessonsQueryHookResult = ReturnType<typeof useGetLessonsQuery>;
export type GetLessonsLazyQueryHookResult = ReturnType<typeof useGetLessonsLazyQuery>;
export type GetLessonsSuspenseQueryHookResult = ReturnType<typeof useGetLessonsSuspenseQuery>;
export type GetLessonsQueryResult = Apollo.QueryResult<GetLessonsQuery, GetLessonsQueryVariables>;
export const LessonDocument = gql`
    query lesson($lessonId: ID!) {
  lesson(lessonId: $lessonId) {
    id
    completeness {
      isComplete
      isDone
    }
    hasFileAnswerQuestion
    dateTo
    exercises {
      id
      title
      type
      isAvailable
      dateTo
      completeness {
        isDone
        isComplete
      }
    }
  }
}
    `;

/**
 * __useLessonQuery__
 *
 * To run a query within a React component, call `useLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useLessonQuery(baseOptions: Apollo.QueryHookOptions<LessonQuery, LessonQueryVariables> & ({ variables: LessonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonQuery, LessonQueryVariables>(LessonDocument, options);
      }
export function useLessonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonQuery, LessonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonQuery, LessonQueryVariables>(LessonDocument, options);
        }
export function useLessonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LessonQuery, LessonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LessonQuery, LessonQueryVariables>(LessonDocument, options);
        }
export type LessonQueryHookResult = ReturnType<typeof useLessonQuery>;
export type LessonLazyQueryHookResult = ReturnType<typeof useLessonLazyQuery>;
export type LessonSuspenseQueryHookResult = ReturnType<typeof useLessonSuspenseQuery>;
export type LessonQueryResult = Apollo.QueryResult<LessonQuery, LessonQueryVariables>;
export const OnboardingCourseCardsDocument = gql`
    query onboardingCourseCards($grade: Float, $subject: CourseSubject) {
  onboardingCourseCards(subject: $subject, grade: $grade) {
    id
    coverFile {
      url
    }
    useDefaultCover
    course {
      id
      title
      grade
      subject
      coverFile {
        url
      }
    }
  }
}
    `;

/**
 * __useOnboardingCourseCardsQuery__
 *
 * To run a query within a React component, call `useOnboardingCourseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCourseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingCourseCardsQuery({
 *   variables: {
 *      grade: // value for 'grade'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useOnboardingCourseCardsQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingCourseCardsQuery, OnboardingCourseCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingCourseCardsQuery, OnboardingCourseCardsQueryVariables>(OnboardingCourseCardsDocument, options);
      }
export function useOnboardingCourseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingCourseCardsQuery, OnboardingCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingCourseCardsQuery, OnboardingCourseCardsQueryVariables>(OnboardingCourseCardsDocument, options);
        }
export function useOnboardingCourseCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardingCourseCardsQuery, OnboardingCourseCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingCourseCardsQuery, OnboardingCourseCardsQueryVariables>(OnboardingCourseCardsDocument, options);
        }
export type OnboardingCourseCardsQueryHookResult = ReturnType<typeof useOnboardingCourseCardsQuery>;
export type OnboardingCourseCardsLazyQueryHookResult = ReturnType<typeof useOnboardingCourseCardsLazyQuery>;
export type OnboardingCourseCardsSuspenseQueryHookResult = ReturnType<typeof useOnboardingCourseCardsSuspenseQuery>;
export type OnboardingCourseCardsQueryResult = Apollo.QueryResult<OnboardingCourseCardsQuery, OnboardingCourseCardsQueryVariables>;
export const BlockPresentationDocument = gql`
    query blockPresentation($blockId: ID!) {
  blockPresentation(blockId: $blockId) {
    id
    title
    cost
  }
}
    `;

/**
 * __useBlockPresentationQuery__
 *
 * To run a query within a React component, call `useBlockPresentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockPresentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockPresentationQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useBlockPresentationQuery(baseOptions: Apollo.QueryHookOptions<BlockPresentationQuery, BlockPresentationQueryVariables> & ({ variables: BlockPresentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockPresentationQuery, BlockPresentationQueryVariables>(BlockPresentationDocument, options);
      }
export function useBlockPresentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockPresentationQuery, BlockPresentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockPresentationQuery, BlockPresentationQueryVariables>(BlockPresentationDocument, options);
        }
export function useBlockPresentationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BlockPresentationQuery, BlockPresentationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockPresentationQuery, BlockPresentationQueryVariables>(BlockPresentationDocument, options);
        }
export type BlockPresentationQueryHookResult = ReturnType<typeof useBlockPresentationQuery>;
export type BlockPresentationLazyQueryHookResult = ReturnType<typeof useBlockPresentationLazyQuery>;
export type BlockPresentationSuspenseQueryHookResult = ReturnType<typeof useBlockPresentationSuspenseQuery>;
export type BlockPresentationQueryResult = Apollo.QueryResult<BlockPresentationQuery, BlockPresentationQueryVariables>;
export const GetTrialDocument = gql`
    mutation getTrial($coursesIds: [ID!]!) {
  getTrial(coursesIds: $coursesIds)
}
    `;
export type GetTrialMutationFn = Apollo.MutationFunction<GetTrialMutation, GetTrialMutationVariables>;

/**
 * __useGetTrialMutation__
 *
 * To run a mutation, you first call `useGetTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTrialMutation, { data, loading, error }] = useGetTrialMutation({
 *   variables: {
 *      coursesIds: // value for 'coursesIds'
 *   },
 * });
 */
export function useGetTrialMutation(baseOptions?: Apollo.MutationHookOptions<GetTrialMutation, GetTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetTrialMutation, GetTrialMutationVariables>(GetTrialDocument, options);
      }
export type GetTrialMutationHookResult = ReturnType<typeof useGetTrialMutation>;
export type GetTrialMutationResult = Apollo.MutationResult<GetTrialMutation>;
export type GetTrialMutationOptions = Apollo.BaseMutationOptions<GetTrialMutation, GetTrialMutationVariables>;
export const InitPaymentDocument = gql`
    mutation initPayment($input: InitResourcePurchaseInput!, $receiptEmail: String) {
  initPayment(input: $input, receiptEmail: $receiptEmail)
}
    `;
export type InitPaymentMutationFn = Apollo.MutationFunction<InitPaymentMutation, InitPaymentMutationVariables>;

/**
 * __useInitPaymentMutation__
 *
 * To run a mutation, you first call `useInitPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initPaymentMutation, { data, loading, error }] = useInitPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      receiptEmail: // value for 'receiptEmail'
 *   },
 * });
 */
export function useInitPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitPaymentMutation, InitPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitPaymentMutation, InitPaymentMutationVariables>(InitPaymentDocument, options);
      }
export type InitPaymentMutationHookResult = ReturnType<typeof useInitPaymentMutation>;
export type InitPaymentMutationResult = Apollo.MutationResult<InitPaymentMutation>;
export type InitPaymentMutationOptions = Apollo.BaseMutationOptions<InitPaymentMutation, InitPaymentMutationVariables>;
export const SendFileInChatBotDocument = gql`
    mutation sendFileInChatBot($elementFileId: ID!) {
  sendFileInChatBot(elementFileId: $elementFileId)
}
    `;
export type SendFileInChatBotMutationFn = Apollo.MutationFunction<SendFileInChatBotMutation, SendFileInChatBotMutationVariables>;

/**
 * __useSendFileInChatBotMutation__
 *
 * To run a mutation, you first call `useSendFileInChatBotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFileInChatBotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFileInChatBotMutation, { data, loading, error }] = useSendFileInChatBotMutation({
 *   variables: {
 *      elementFileId: // value for 'elementFileId'
 *   },
 * });
 */
export function useSendFileInChatBotMutation(baseOptions?: Apollo.MutationHookOptions<SendFileInChatBotMutation, SendFileInChatBotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFileInChatBotMutation, SendFileInChatBotMutationVariables>(SendFileInChatBotDocument, options);
      }
export type SendFileInChatBotMutationHookResult = ReturnType<typeof useSendFileInChatBotMutation>;
export type SendFileInChatBotMutationResult = Apollo.MutationResult<SendFileInChatBotMutation>;
export type SendFileInChatBotMutationOptions = Apollo.BaseMutationOptions<SendFileInChatBotMutation, SendFileInChatBotMutationVariables>;
export const SetUserCommentDocument = gql`
    mutation setUserComment($comment: String!) {
  setUserComment(comment: $comment)
}
    `;
export type SetUserCommentMutationFn = Apollo.MutationFunction<SetUserCommentMutation, SetUserCommentMutationVariables>;

/**
 * __useSetUserCommentMutation__
 *
 * To run a mutation, you first call `useSetUserCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserCommentMutation, { data, loading, error }] = useSetUserCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetUserCommentMutation(baseOptions?: Apollo.MutationHookOptions<SetUserCommentMutation, SetUserCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserCommentMutation, SetUserCommentMutationVariables>(SetUserCommentDocument, options);
      }
export type SetUserCommentMutationHookResult = ReturnType<typeof useSetUserCommentMutation>;
export type SetUserCommentMutationResult = Apollo.MutationResult<SetUserCommentMutation>;
export type SetUserCommentMutationOptions = Apollo.BaseMutationOptions<SetUserCommentMutation, SetUserCommentMutationVariables>;
export const UpdateUserDataDocument = gql`
    mutation updateUserData($input: SelfUpdateUserDataInput!) {
  updateUserData(input: $input) {
    id
    avatarFile {
      url
    }
    birthDate
    firstName
    lastName
    middleName
    phoneNumber
    telegramUsername
    comment
  }
}
    `;
export type UpdateUserDataMutationFn = Apollo.MutationFunction<UpdateUserDataMutation, UpdateUserDataMutationVariables>;

/**
 * __useUpdateUserDataMutation__
 *
 * To run a mutation, you first call `useUpdateUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDataMutation, { data, loading, error }] = useUpdateUserDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDataMutation, UpdateUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDataMutation, UpdateUserDataMutationVariables>(UpdateUserDataDocument, options);
      }
export type UpdateUserDataMutationHookResult = ReturnType<typeof useUpdateUserDataMutation>;
export type UpdateUserDataMutationResult = Apollo.MutationResult<UpdateUserDataMutation>;
export type UpdateUserDataMutationOptions = Apollo.BaseMutationOptions<UpdateUserDataMutation, UpdateUserDataMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    firstName
    lastName
    middleName
    registerInBot
    telegramUsername
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserCourseCardsDocument = gql`
    query userCourseCards {
  availableCourseCards {
    id
    description
    useDefaultCover
    type
    coverFile {
      url
    }
    course {
      id
      title
      subject
      coverFile {
        url
      }
    }
    link
  }
  userAdvertisingCourseCard {
    id
    description
    useDefaultCover
    type
    coverFile {
      url
    }
    course {
      id
      title
      subject
      coverFile {
        url
      }
    }
    link
  }
}
    `;

/**
 * __useUserCourseCardsQuery__
 *
 * To run a query within a React component, call `useUserCourseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCourseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCourseCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCourseCardsQuery(baseOptions?: Apollo.QueryHookOptions<UserCourseCardsQuery, UserCourseCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCourseCardsQuery, UserCourseCardsQueryVariables>(UserCourseCardsDocument, options);
      }
export function useUserCourseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCourseCardsQuery, UserCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCourseCardsQuery, UserCourseCardsQueryVariables>(UserCourseCardsDocument, options);
        }
export function useUserCourseCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCourseCardsQuery, UserCourseCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCourseCardsQuery, UserCourseCardsQueryVariables>(UserCourseCardsDocument, options);
        }
export type UserCourseCardsQueryHookResult = ReturnType<typeof useUserCourseCardsQuery>;
export type UserCourseCardsLazyQueryHookResult = ReturnType<typeof useUserCourseCardsLazyQuery>;
export type UserCourseCardsSuspenseQueryHookResult = ReturnType<typeof useUserCourseCardsSuspenseQuery>;
export type UserCourseCardsQueryResult = Apollo.QueryResult<UserCourseCardsQuery, UserCourseCardsQueryVariables>;
export const UserProfileDocument = gql`
    query userProfile {
  me {
    id
    avatarFile {
      url
    }
    birthDate
    lastName
    firstName
    middleName
    phoneNumber
    telegramUsername
    comment
  }
}
    `;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export function useUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileSuspenseQueryHookResult = ReturnType<typeof useUserProfileSuspenseQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;